module.exports = __webpack_public_path__ + "img/0a465117154b4cd38b465bd5159000b6-1440.3508fc14.jpg";